import fetch from "../fetch";

export default ({ dealCode, id }) =>
  fetch({
    method: "DELETE",
    path: `/abs/deals/${dealCode}/geo-distributions/${id}`
  });
